// extracted by mini-css-extract-plugin
export default {"container":"_10f5a533"};